import React from 'react'
import { Menu, Icon, Spin, Dropdown, Avatar, Divider, Breadcrumb } from 'antd'
import _ from 'lodash'
import User, { UserContext, IUserContext } from 'modules/User'
import { appModule } from 'services/module'
import { Link } from 'react-router-dom'
import '../../../styles/app-modeling-layout.less'

interface IGlobalHeaderProps {
	routeData?: any
	changeState: (e: any) => void
}
const modelingModuleList = [
	{ name: '数据对象', path: '/modeling/entity' },
	{ name: '导航模块', path: '/modeling/module' },
	{ name: '页面组件', path: '/modeling/page' },
	{ name: '业务参数', path: '/modeling/parameters' },
	{ name: '接口事件', path: '/modeling/event' },
]

export default class extends React.PureComponent<IGlobalHeaderProps> {
	renderHeader = ({ user, setModelingSystemCode }: IUserContext) => {
		let acticveRouter =
			modelingModuleList.find(modelingModule => modelingModule.path === window.location.pathname) ||
			modelingModuleList[0]

		let currModelingSystemCode = appModule.getCurrentModelingSystem().code;
		let systemList = appModule.getSystemList();
		if(systemList.length===0) return null;
		let currModelingSystem = systemList.find(o => o.code === currModelingSystemCode) || systemList[0]
		return (
			<div className="modeling-header">
				<div className="header-content modeling-content-width">
					<span className="header-title">建模平台</span>
					<div className="header-modules">
						{modelingModuleList.map((moduleItem, index) => {
							return (
								<Link to={moduleItem.path!} replace={false} key={index}>
									<span className={moduleItem.path === acticveRouter.path ? 'module-item-active':''}>
										{moduleItem.name}
									</span>
								</Link>
							)
						})}
					</div>
					<div className="header-userinfo">
						<div className="userinfo-warn">
							<img src="/extendicon/img/news.png"></img>
							<img src="/extendicon/img/quesion.png"></img>
						</div>
						<i className="interruptline"></i>
						<div className="userinfo-systemselect" onClick={this.props.changeState}>
							{currModelingSystem.name}
							<i></i>
						</div>
						<i className="interruptline"></i>
						<span className="userinfo-username">{user.userName}</span>
					</div>
				</div>
			</div>
		)
	}

	render() {
		return <UserContext.Consumer>{this.renderHeader}</UserContext.Consumer>
	}
}



// WEBPACK FOOTER //
// ./src/layouts/components/ModelingHeader/index.tsx